import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "mb-4" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "form-floating mb-3" };
const _hoisted_5 = { value: "b2b" };
const _hoisted_6 = {
    key: 0,
    value: "b2c"
};
const _hoisted_7 = { for: "customerType" };
const _hoisted_8 = { class: "row mb-3" };
const _hoisted_9 = { class: "col-12 col-lg-6" };
const _hoisted_10 = { class: "fw-bold mb-3" };
const _hoisted_11 = {
    key: 0,
    class: "form-floating mb-3"
};
const _hoisted_12 = { selected: "" };
const _hoisted_13 = ["value"];
const _hoisted_14 = { for: "preSelectedInvoiceAddress" };
const _hoisted_15 = { class: "form-floating mb-3" };
const _hoisted_16 = { for: "invoiceAddressCompany" };
const _hoisted_17 = { class: "form-floating mb-3" };
const _hoisted_18 = { for: "invoiceAddressFirstname" };
const _hoisted_19 = { class: "form-floating mb-3" };
const _hoisted_20 = { for: "invoiceAddressLastname" };
const _hoisted_21 = { class: "form-floating mb-3" };
const _hoisted_22 = { for: "invoiceAddressStreet" };
const _hoisted_23 = { class: "form-floating mb-3" };
const _hoisted_24 = { for: "invoiceAddressZipcode" };
const _hoisted_25 = { class: "form-floating mb-3" };
const _hoisted_26 = { for: "invoiceAddressCity" };
const _hoisted_27 = { class: "form-floating mb-3" };
const _hoisted_28 = ["value"];
const _hoisted_29 = { for: "invoiceAddressCountry" };
const _hoisted_30 = { class: "form-floating mb-3" };
const _hoisted_31 = { for: "invoiceAddressEmail" };
const _hoisted_32 = { class: "form-floating" };
const _hoisted_33 = { for: "invoiceAddressPhone" };
const _hoisted_34 = { class: "form-text mb-3" };
const _hoisted_35 = { class: "form-check mb-3" };
const _hoisted_36 = {
    class: "form-check-label",
    for: "deliveryIsSameAsInvoice"
};
const _hoisted_37 = {
    key: 0,
    class: "col-12 col-lg-6"
};
const _hoisted_38 = { class: "fw-bold mb-3" };
const _hoisted_39 = {
    key: 0,
    class: "form-floating mb-3"
};
const _hoisted_40 = { selected: "" };
const _hoisted_41 = ["value"];
const _hoisted_42 = { for: "preSelectedDeliveryAddress" };
const _hoisted_43 = { class: "form-floating mb-3" };
const _hoisted_44 = { for: "deliveryAddressCompany" };
const _hoisted_45 = { class: "form-floating mb-3" };
const _hoisted_46 = { for: "deliveryAddressFirstname" };
const _hoisted_47 = { class: "form-floating mb-3" };
const _hoisted_48 = { for: "deliveryAddressLastname" };
const _hoisted_49 = { class: "form-floating mb-3" };
const _hoisted_50 = { for: "deliveryAddressStreet" };
const _hoisted_51 = { class: "form-floating mb-3" };
const _hoisted_52 = { for: "deliveryAddressZipcode" };
const _hoisted_53 = { class: "form-floating mb-3" };
const _hoisted_54 = { for: "deliveryAddressCity" };
const _hoisted_55 = { class: "form-floating mb-3" };
const _hoisted_56 = ["value"];
const _hoisted_57 = { for: "deliveryAddressCountry" };
const _hoisted_58 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_59 = { class: "form-check mb-1" };
const _hoisted_60 = {
    class: "form-check-label",
    for: "createOrderRequestCreateUserAccount"
};
const _hoisted_61 = { class: "form-text mb-3" };
const _hoisted_62 = { key: 0 };
const _hoisted_63 = { class: "form-floating mb-3" };
const _hoisted_64 = { for: "createOrderRequestPassword" };
const _hoisted_65 = { class: "form-floating mb-3" };
const _hoisted_66 = { for: "createOrderRequestPasswordConfirmation" };
const _hoisted_67 = {
    key: 0,
    class: "fw-bold text-danger"
};
const _hoisted_68 = { class: "d-flex" };
const _hoisted_69 = ["disabled"];
const _hoisted_70 = { class: "ms-2" };
const _hoisted_71 = { class: "mb-5" };
import axios from 'axios';
import { onMounted, ref, watch } from 'vue';
import { useForm, usePage } from '@inertiajs/vue3';
import { responseMessages } from '@/Composables/responseMessages';
import { useI18n } from 'vue-i18n';
import CustomerLoginAndRegistrationForm from '@/Shared/CustomerLoginAndRegistrationForm.vue';
import ContextModal from './ContextModal.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartCustomerData',
    props: {
        tenantId: String,
        orderRequestUuid: {
            type: String,
            required: true
        },
        countries: {
            type: Object,
            required: true
        }
    },
    emits: ['update', 'close'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        let { showSuccessSwal, showErrorSwal } = responseMessages();
        const emit = __emit;
        const props = __props;
        const userLoginModal = ref();
        const loggedInUser = ref(usePage().props.auth.user);
        const customer = ref(usePage().props.auth.customer);
        const customerData = ref(null);
        const privateCustomersAllowed = ref(false);
        const preSelectedInvoiceAddress = ref(null);
        const preSelectedDeliveryAddress = ref(null);
        const addressFrom = useForm({
            customerType: 'b2b',
            invoiceCompany: null,
            invoiceFirstname: null,
            invoiceLastname: null,
            invoiceStreet: null,
            invoiceZipcode: null,
            invoiceCity: null,
            invoiceCountry: null,
            invoiceEmail: null,
            invoicePhone: null,
            deliveryCompany: null,
            deliveryFirstname: null,
            deliveryLastname: null,
            deliveryStreet: null,
            deliveryZipcode: null,
            deliveryCity: null,
            deliveryCountry: null,
            deliveryIsSameAsInvoice: false,
            createUserAccount: false,
            password: null,
            passwordConfirmation: null,
        });
        onMounted(() => {
            loadCustomerData();
        });
        watch(preSelectedInvoiceAddress, (newValue) => {
            if (newValue) {
                addressFrom.invoiceCompany = newValue.company;
                addressFrom.invoiceFirstname = newValue.firstname;
                addressFrom.invoiceLastname = newValue.lastname;
                addressFrom.invoiceStreet = newValue.street;
                addressFrom.invoiceZipcode = newValue.zipcode;
                addressFrom.invoiceCity = newValue.city;
                addressFrom.invoiceCountry = newValue.countryId;
                if (addressFrom.invoiceEmail == null) {
                    addressFrom.invoiceEmail = customer.value ? customer.value.email : null;
                }
                if (addressFrom.invoicePhone == null) {
                    addressFrom.invoicePhone = customer.value ? customer.value.phone : null;
                }
            }
        });
        watch(preSelectedDeliveryAddress, (newValue) => {
            if (newValue) {
                addressFrom.deliveryCompany = newValue.company;
                addressFrom.deliveryFirstname = newValue.firstname;
                addressFrom.deliveryLastname = newValue.lastname;
                addressFrom.deliveryStreet = newValue.street;
                addressFrom.deliveryZipcode = newValue.zipcode;
                addressFrom.deliveryCity = newValue.city;
                addressFrom.deliveryCountry = newValue.countryId;
            }
        });
        function loadUserData() {
            axios.get(route('configurator.userLoader.load'))
                .then(function (response) {
                loggedInUser.value = response.data.user;
                customer.value = response.data.customer;
                userLoginModal.value.close();
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function loadCustomerData() {
            axios.post(route('cart.customerData.load', props.orderRequestUuid))
                .then(function (response) {
                customerData.value = response.data.customerData;
                privateCustomersAllowed.value = response.data.privateCustomersAllowed;
                if (customerData.value) {
                    addressFrom.customerType = customerData.value.customerType;
                    addressFrom.invoiceCompany = customerData.value.invoiceCompany;
                    addressFrom.invoiceFirstname = customerData.value.invoiceFirstname;
                    addressFrom.invoiceLastname = customerData.value.invoiceLastname;
                    addressFrom.invoiceStreet = customerData.value.invoiceStreet;
                    addressFrom.invoiceZipcode = customerData.value.invoiceZipcode;
                    addressFrom.invoiceCity = customerData.value.invoiceCity;
                    addressFrom.invoiceCountry = customerData.value.invoiceCountry;
                    addressFrom.invoiceEmail = customerData.value.invoiceEmail;
                    addressFrom.invoicePhone = customerData.value.invoicePhone;
                    addressFrom.deliveryCompany = customerData.value.deliveryCompany;
                    addressFrom.deliveryFirstname = customerData.value.deliveryFirstname;
                    addressFrom.deliveryLastname = customerData.value.deliveryLastname;
                    addressFrom.deliveryStreet = customerData.value.deliveryStreet;
                    addressFrom.deliveryZipcode = customerData.value.deliveryZipcode;
                    addressFrom.deliveryCity = customerData.value.deliveryCity;
                    addressFrom.deliveryCountry = customerData.value.deliveryCountry;
                    addressFrom.deliveryIsSameAsInvoice = customerData.value.deliveryIsSameAsInvoice;
                    addressFrom.createUserAccount = customerData.value.createUserAccount;
                    addressFrom.password = customerData.value.password;
                    addressFrom.passwordConfirmation = customerData.value.password;
                }
            })
                .catch(function (error) {
                console.error(error);
            });
        }
        function updateCustomerData() {
            axios.post(route('cart.customerData.store', props.orderRequestUuid), {
                customer_type: addressFrom.customerType,
                invoice_company: addressFrom.invoiceCompany,
                invoice_firstname: addressFrom.invoiceFirstname,
                invoice_lastname: addressFrom.invoiceLastname,
                invoice_street: addressFrom.invoiceStreet,
                invoice_zipcode: addressFrom.invoiceZipcode,
                invoice_city: addressFrom.invoiceCity,
                invoice_country: addressFrom.invoiceCountry,
                invoice_email: addressFrom.invoiceEmail,
                invoice_phone: addressFrom.invoicePhone,
                delivery_company: addressFrom.deliveryCompany,
                delivery_firstname: addressFrom.deliveryFirstname,
                delivery_lastname: addressFrom.deliveryLastname,
                delivery_street: addressFrom.deliveryStreet,
                delivery_zipcode: addressFrom.deliveryZipcode,
                delivery_city: addressFrom.deliveryCity,
                delivery_country: addressFrom.deliveryCountry,
                delivery_is_same_as_invoice: addressFrom.deliveryIsSameAsInvoice,
                create_user_account: addressFrom.createUserAccount,
                password: addressFrom.password,
                password_confirmation: addressFrom.passwordConfirmation,
            })
                .then(function (response) {
                if (response.status == 200) {
                    loadCustomerData();
                    emit('update');
                    showSuccessSwal(t('Liefer- und Rechnungsanschrift wurden aktualisiert.'));
                }
                else {
                    showErrorSwal(response.data);
                }
            })
                .catch(function (error) {
                console.log(error);
                showErrorSwal(error);
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(t)('Rechnungs- & Lieferanschrift')), 1),
                (loggedInUser.value == null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("p", null, _toDisplayString(_unref(t)('Sie haben bereits ein Nutzerkonto? Als eingeloggter Nutzer können Sie Anfragen und Bestellungen wesentlich schneller durchführen.')), 1),
                        _createElementVNode("button", {
                            class: "btn btn-primary mb-3",
                            type: "button",
                            onClick: _cache[0] || (_cache[0] = ($event) => (userLoginModal.value.open()))
                        }, _toDisplayString(_unref(t)('Ich habe bereits ein Nutzerkonto')), 1)
                    ]))
                    : _createCommentVNode("", true),
                (loggedInUser.value && customer.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("p", null, [
                            _cache[25] || (_cache[25] = _createTextVNode("Eingeloggt als ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(loggedInUser.value.firstname) + " " + _toDisplayString(loggedInUser.value.lastname) + " (" + _toDisplayString(customer.value.company) + ")", 1),
                            _cache[26] || (_cache[26] = _createTextVNode(".", -1))
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("form", {
                    onSubmit: _withModifiers(updateCustomerData, ["prevent"])
                }, [
                    _createElementVNode("div", _hoisted_4, [
                        _withDirectives(_createElementVNode("select", {
                            class: "form-select",
                            id: "customerType",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(addressFrom).customerType) = $event)),
                            required: ""
                        }, [
                            _createElementVNode("option", _hoisted_5, _toDisplayString(_unref(t)('Gewerblich')), 1),
                            (privateCustomersAllowed.value)
                                ? (_openBlock(), _createElementBlock("option", _hoisted_6, _toDisplayString(_unref(t)('Privat')), 1))
                                : _createCommentVNode("", true)
                        ], 512), [
                            [_vModelSelect, _unref(addressFrom).customerType]
                        ]),
                        _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)('Gewerblicher/privater Kunde')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("h5", _hoisted_10, _toDisplayString(_unref(t)('Rechnungsanschrift')), 1),
                            (loggedInUser.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _withDirectives(_createElementVNode("select", {
                                        class: "form-select",
                                        id: "preSelectedInvoiceAddress",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((preSelectedInvoiceAddress).value = $event))
                                    }, [
                                        _createElementVNode("option", _hoisted_12, _toDisplayString(_unref(t)('Neue Anschrift anlegen')), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.value.addresses, (address) => {
                                            return (_openBlock(), _createElementBlock("option", { value: address }, _toDisplayString(address.company) + ", " + _toDisplayString(address.firstname) + " " + _toDisplayString(address.lastname) + ", " + _toDisplayString(address.street) + ", " + _toDisplayString(address.zipcode) + " " + _toDisplayString(address.city), 9, _hoisted_13));
                                        }), 256))
                                    ], 512), [
                                        [_vModelSelect, preSelectedInvoiceAddress.value]
                                    ]),
                                    _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(t)('Bestehende Anschrift nutzen')), 1)
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_15, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "invoiceAddressCompany",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(addressFrom).invoiceCompany) = $event))
                                }, null, 512), [
                                    [_vModelText, _unref(addressFrom).invoiceCompany]
                                ]),
                                _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(t)('Firma')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "invoiceAddressFirstname",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(addressFrom).invoiceFirstname) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(addressFrom).invoiceFirstname]
                                ]),
                                _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(t)('Vorname')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "invoiceAddressLastname",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(addressFrom).invoiceLastname) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(addressFrom).invoiceLastname]
                                ]),
                                _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(t)('Nachname')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "invoiceAddressStreet",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(addressFrom).invoiceStreet) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(addressFrom).invoiceStreet]
                                ]),
                                _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(t)('Adresse')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "invoiceAddressZipcode",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(addressFrom).invoiceZipcode) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(addressFrom).invoiceZipcode]
                                ]),
                                _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(t)('Postleitzahl')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "invoiceAddressCity",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(addressFrom).invoiceCity) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(addressFrom).invoiceCity]
                                ]),
                                _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(t)('Stadt')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                                _withDirectives(_createElementVNode("select", {
                                    class: "form-select",
                                    id: "invoiceAddressCountry",
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(addressFrom).invoiceCountry) = $event)),
                                    required: ""
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.countries, (country) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            value: country.id
                                        }, _toDisplayString(country.name), 9, _hoisted_28));
                                    }), 256))
                                ], 512), [
                                    [_vModelSelect, _unref(addressFrom).invoiceCountry]
                                ]),
                                _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(t)('Land')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "email",
                                    class: "form-control",
                                    id: "invoiceAddressEmail",
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(addressFrom).invoiceEmail) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(addressFrom).invoiceEmail]
                                ]),
                                _createElementVNode("label", _hoisted_31, _toDisplayString(_unref(t)('E-Mail')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "invoiceAddressPhone",
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(addressFrom).invoicePhone) = $event)),
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _unref(addressFrom).invoicePhone]
                                ]),
                                _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(t)('Telefon')), 1)
                            ]),
                            _createElementVNode("p", _hoisted_34, _toDisplayString(_unref(t)('Für schnelle Rückfragen zu Ihrer Bestellung')), 1),
                            _createElementVNode("div", _hoisted_35, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: "1",
                                    id: "deliveryIsSameAsInvoice",
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(addressFrom).deliveryIsSameAsInvoice) = $event))
                                }, null, 512), [
                                    [_vModelCheckbox, _unref(addressFrom).deliveryIsSameAsInvoice]
                                ]),
                                _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(t)('Liefer-Anschrift wie Rechnungs-Anschrift')), 1)
                            ])
                        ]),
                        (!_unref(addressFrom).deliveryIsSameAsInvoice)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("h5", _hoisted_38, _toDisplayString(_unref(t)('Lieferanschrift')), 1),
                                (loggedInUser.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                        _withDirectives(_createElementVNode("select", {
                                            class: "form-select",
                                            id: "preSelectedDeliveryAddress",
                                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((preSelectedDeliveryAddress).value = $event))
                                        }, [
                                            _createElementVNode("option", _hoisted_40, _toDisplayString(_unref(t)('Neue Anschrift anlegen')), 1),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.value.addresses, (address) => {
                                                return (_openBlock(), _createElementBlock("option", { value: address }, _toDisplayString(address.company) + ", " + _toDisplayString(address.firstname) + " " + _toDisplayString(address.lastname) + ", " + _toDisplayString(address.street) + ", " + _toDisplayString(address.zipcode) + " " + _toDisplayString(address.city), 9, _hoisted_41));
                                            }), 256))
                                        ], 512), [
                                            [_vModelSelect, preSelectedDeliveryAddress.value]
                                        ]),
                                        _createElementVNode("label", _hoisted_42, _toDisplayString(_unref(t)('Bestehende Anschrift nutzen')), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_43, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "deliveryAddressCompany",
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(addressFrom).deliveryCompany) = $event))
                                    }, null, 512), [
                                        [_vModelText, _unref(addressFrom).deliveryCompany]
                                    ]),
                                    _createElementVNode("label", _hoisted_44, _toDisplayString(_unref(t)('Firma')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_45, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "deliveryAddressFirstname",
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_unref(addressFrom).deliveryFirstname) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, _unref(addressFrom).deliveryFirstname]
                                    ]),
                                    _createElementVNode("label", _hoisted_46, _toDisplayString(_unref(t)('Vorname')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_47, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "deliveryAddressLastname",
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_unref(addressFrom).deliveryLastname) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, _unref(addressFrom).deliveryLastname]
                                    ]),
                                    _createElementVNode("label", _hoisted_48, _toDisplayString(_unref(t)('Nachname')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "deliveryAddressStreet",
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_unref(addressFrom).deliveryStreet) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, _unref(addressFrom).deliveryStreet]
                                    ]),
                                    _createElementVNode("label", _hoisted_50, _toDisplayString(_unref(t)('Adresse')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_51, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "deliveryAddressZipcode",
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_unref(addressFrom).deliveryZipcode) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, _unref(addressFrom).deliveryZipcode]
                                    ]),
                                    _createElementVNode("label", _hoisted_52, _toDisplayString(_unref(t)('Postleitzahl')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_53, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control",
                                        id: "deliveryAddressCity",
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_unref(addressFrom).deliveryCity) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, _unref(addressFrom).deliveryCity]
                                    ]),
                                    _createElementVNode("label", _hoisted_54, _toDisplayString(_unref(t)('Stadt')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_55, [
                                    _withDirectives(_createElementVNode("select", {
                                        class: "form-select",
                                        id: "deliveryAddressCountry",
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_unref(addressFrom).deliveryCountry) = $event)),
                                        required: ""
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.countries, (country) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                value: country.id
                                            }, _toDisplayString(country.name), 9, _hoisted_56));
                                        }), 256))
                                    ], 512), [
                                        [_vModelSelect, _unref(addressFrom).deliveryCountry]
                                    ]),
                                    _createElementVNode("label", _hoisted_57, _toDisplayString(_unref(t)('Land')), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (loggedInUser.value == null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: "1",
                                    id: "createOrderRequestCreateUserAccount",
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_unref(addressFrom).createUserAccount) = $event))
                                }, null, 512), [
                                    [_vModelCheckbox, _unref(addressFrom).createUserAccount]
                                ]),
                                _createElementVNode("label", _hoisted_60, _toDisplayString(_unref(t)('Benutzer-Account erstellen?')), 1)
                            ]),
                            _createElementVNode("p", _hoisted_61, _toDisplayString(_unref(t)('Ein Benutzer-Account ermöglicht schnellere Anfragen & Bestellungen, sowie die einfache Verwaltung sämtlicher Konfigurationen, Anfragen und Bestellungen.')), 1),
                            (_unref(addressFrom).createUserAccount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                    _createElementVNode("div", _hoisted_63, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "password",
                                            class: "form-control",
                                            id: "createOrderRequestPassword",
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_unref(addressFrom).password) = $event)),
                                            required: ""
                                        }, null, 512), [
                                            [_vModelText, _unref(addressFrom).password]
                                        ]),
                                        _createElementVNode("label", _hoisted_64, _toDisplayString(_unref(t)('Passwort')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_65, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "password",
                                            class: "form-control",
                                            id: "createOrderRequestPasswordConfirmation",
                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_unref(addressFrom).passwordConfirmation) = $event)),
                                            required: ""
                                        }, null, 512), [
                                            [_vModelText, _unref(addressFrom).passwordConfirmation]
                                        ]),
                                        _createElementVNode("label", _hoisted_66, _toDisplayString(_unref(t)('Passwort wiederholen')), 1)
                                    ]),
                                    (_unref(addressFrom).password != '' && _unref(addressFrom).passwordConfirmation != '' && _unref(addressFrom).password != _unref(addressFrom).passwordConfirmation)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_67, _toDisplayString(_unref(t)('Passwörter stimmen nicht überein')), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("p", null, _toDisplayString(_unref(t)('Der Benutzeraccount wird direkt bei Bestellabschluss angelegt.')), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("button", {
                            class: "btn btn-secondary text-white rounded-5 d-flex align-items-center me-4",
                            onClick: _cache[24] || (_cache[24] = ($event) => (emit('close')))
                        }, _toDisplayString(_unref(t)('zurück')), 1),
                        _createElementVNode("button", {
                            typeof: "submit",
                            class: "btn btn-primary rounded-5 d-flex align-items-center",
                            disabled: _unref(addressFrom).password != '' && _unref(addressFrom).passwordConfirmation != '' && _unref(addressFrom).password != _unref(addressFrom).passwordConfirmation
                        }, [
                            _cache[27] || (_cache[27] = _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                fill: "currentColor",
                                class: "bi bi-check2-circle",
                                viewBox: "0 0 16 16"
                            }, [
                                _createElementVNode("path", { d: "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" }),
                                _createElementVNode("path", { d: "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" })
                            ], -1)),
                            _createElementVNode("span", _hoisted_70, _toDisplayString(_unref(t)('Speichern')), 1)
                        ], 8, _hoisted_69)
                    ])
                ], 32),
                _createVNode(ContextModal, {
                    ref_key: "userLoginModal",
                    ref: userLoginModal,
                    size: 'sm'
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_71, [
                            _createVNode(CustomerLoginAndRegistrationForm, {
                                tenantId: props.tenantId,
                                allowRegistration: false,
                                onLoggedIn: loadUserData
                            }, null, 8, ["tenantId"])
                        ])
                    ]),
                    _: 1
                }, 512)
            ], 64));
        };
    }
});
